import React, { useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import List from "devextreme-react/list";
import Button from "devextreme-react/button";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import useHandleTaskRates from "../../Hooks/useHandleData/useHandleTaskRates";
import AddPopup from "./Components/addPopup";
import EditPopup from "./Components/editPopup";
import ErrorMessage from "../../Components/ErrorMessage";
import "./styles.css";

export default function TasksPage() {
  const params = useParams(),
    location = useLocation();

  const [addPopup, setAddPopup] = useState(false),
    [editPopup, setEditPopup] = useState(false),
    [addFormData, setAddFormData] = useState({
      task: {
        id: params.taskId,
      },
      industry: 0,
      federal: 0,
      overhead: 0,
    }),
    [editFormData, setEditFormData] = useState({}),
    { allTaskRates, isLoading, error } = useHandleTaskRates(params.taskId);

  const groupRender = (e) => {
    const onEditClick = () => {
      const arr = e.items;
      let industry, federal, overhead;

      arr.forEach((x) => {
        const [key, value] = x.split(": ");
        switch (key.toLowerCase()) {
          case "industry":
            industry = Number(value);
            break;
          case "federal":
            federal = Number(value);
            break;
          case "overhead":
            overhead = Number(value);
            break;
          default:
            break;
        }
      });

      setEditFormData({
        id: e.id,
        task: {
          id: params.taskId,
        },
        year: e.year,
        industry: industry,
        federal: federal,
        overhead: overhead,
      });
      setEditPopup(true);
    };

    return (
      <>
        <div>{e.year}</div>
        <Button icon="edit" onClick={() => onEditClick()} />
      </>
    );
  };

  const renderData = () => {
    return (
      <>
        <h4 className="white">{location.state.name}</h4>
        <Link
          className="hoverLinkText gray"
          to="/workCenters"
          state={{ popup: true }}
        >
          <h5 className="white">&#x2190; Tasks</h5>
        </Link>
        <List
          dataSource={allTaskRates}
          height="75vh"
          grouped={true}
          collapsibleGroups={true}
          groupRender={groupRender}
        />
        <Button
          className="task-rate-button"
          text="Add Task Rate"
          onClick={() => setAddPopup(true)}
        />

        {addPopup && (
          <AddPopup
            popup={addPopup}
            setPopup={setAddPopup}
            formData={addFormData}
            setFormData={setAddFormData}
          />
        )}
        {editPopup && (
          <EditPopup
            popup={editPopup}
            setPopup={setEditPopup}
            formData={editFormData}
            setFormData={setEditFormData}
          />
        )}
      </>
    );
  };

  if (isLoading) return <LoadingSpinnerModal show={true} />;

  return (
    <>
      <div className="task-rate-page contentBox">
        {!error ? renderData() : <ErrorMessage />}
      </div>
    </>
  );
}
